import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DirectSearchAPIInput, GetRamiVitaResponse, GetRiskLevelsResponse, PolicyDetail } from 'models';
import { Subject } from 'rxjs';
import { ApiService } from 'src/_utility/api';

@Injectable({
  providedIn: 'root'
})
export class DirectSearchService {
  
  private ramiVita: GetRamiVitaResponse[];
  private riskLevels: GetRiskLevelsResponse[];
  private directSearchInput: DirectSearchAPIInput;
  private searchResult: PolicyDetail[];

  onSearchLoaded: Subject<PolicyDetail[]> = new Subject();
  onIsResultsShown: Subject<boolean> = new Subject();

  constructor(
    private api: ApiService,
    private snackBar: MatSnackBar
  ) { }

  /**
   * 
   * @returns 
   */
  public getRamiVita(): GetRamiVitaResponse[] {
    return this.ramiVita
  }

  /**
   * 
   * @param rv 
   */
  public setRamiVita(rv: GetRamiVitaResponse[]) {
    this.ramiVita = rv;
  }
  
  /**
   * 
   * @returns 
   */
  public getRiskLevels(): GetRiskLevelsResponse[] {
    return this.riskLevels
  }

  /**
   * 
   * @param rl 
   */
  public setRiskLevels(rl: GetRiskLevelsResponse[]) {
    this.riskLevels = rl;
  }

  public getDirectSearchInput(): DirectSearchAPIInput {
    return this.directSearchInput
  }

  public setSearchInput(i: DirectSearchAPIInput) {
    this.directSearchInput = i;
  }

  setSearchResult(fResult: PolicyDetail[]) {
    this.searchResult = fResult
  }

  getSearchResult(): PolicyDetail[] {
    return this.searchResult
  }

  loadSearch(input: DirectSearchAPIInput, callback: (() => void) = null) {
    this.api.getProductsDS(input)
      .then(data => {
        this.setSearchResult(data?.Instruments ?? []);
        this.onSearchLoaded.next(this.searchResult);
        callback();
      })
      .catch(err => {
        this.searchResult = undefined;
        this.onSearchLoaded.next(undefined);
        this.snackBar.open("E' stato riscontrato un problema durante la ricerca.", 'Chiudi', { duration: 5000 })
        callback();
      })
  }

}
